var map = {
	"./main-1_active.png": "b87d",
	"./main-2_active.png": "be1d",
	"./main-3_active.png": "d707",
	"./main-4_active.png": "4e1c",
	"./main-5_active.png": "f8ce",
	"./main-6_active.png": "a551"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4f3f";